<ng-container *ngIf="showChrome; else plainList">
  <div class="dashboard-widget-card">
    <app-widget-card-header
      [title]="widget.title"
      [isMockPreview]="isMockPreview"
      [isEditable]="isEditable"
      [canDelete]="canDelete"
      [isEditMode]="isEditMode"
      [sensorTypeLabels]="sensorTypeLabels"
      (edit)="edit.emit()"
      (remove)="remove.emit()">
    </app-widget-card-header>

    <div class="dashboard-widget-card__content">
      <ng-container *ngTemplateOutlet="plainList"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #plainList>
  <div class="widget-device-list">
    <div class="widget-list-row" *ngFor="let row of rows">
      <div class="widget-list-row__bar" [style.background]="row.color"></div>
      <span class="widget-list-row__label">{{ row.label }}</span>
      <div class="widget-list-row__value-wrap">
        <span class="widget-list-row__value" [style.color]="row.color">{{ row.value }}</span>
        <span class="widget-list-row__unit" *ngIf="row.unit">{{ row.unit }}</span>
      </div>
    </div>
    <div class="widget-list-empty" *ngIf="rows.length === 0">
      <div class="widget-list-empty__lines" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <span>Sin datos disponibles</span>
    </div>
  </div>
</ng-template>
